"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var black_1 = require("./black");
exports.black = black_1.default;
var bold_1 = require("./bold");
exports.bold = bold_1.default;
var book_1 = require("./book");
exports.book = book_1.default;
var light_1 = require("./light");
exports.light = light_1.default;
var regular_1 = require("./regular");
exports.regular = regular_1.default;
var semibold_1 = require("./semibold");
exports.semibold = semibold_1.default;
//# sourceMappingURL=index.js.map